const LAST_C0_CONTROL_CODE = 0x1f
const DELETE_CODE = 0x7f

export const hasControlChars = (value: string): boolean =>
  [...value].some((char) => {
    const code = char.charCodeAt(0)
    return code <= LAST_C0_CONTROL_CODE || code === DELETE_CODE
  })

export const sanitizeRedirectPath = (value: string | null | undefined): string | null => {
  if (!value) {
    return null
  }
  // Only same-origin absolute paths. "//host" and "https://host" are browser-navigable
  // elsewhere, and the param is now reachable from any emailed link.
  if (!value.startsWith('/') || value.startsWith('//')) {
    return null
  }
  if (hasControlChars(value)) {
    return null
  }

  return value
}

export const buildRedirectSearch = (path: string | null): string =>
  path ? `?redirect=${encodeURIComponent(path)}` : ''
